import React, { useEffect, useState } from "react";
import callApi from "services/api";
import { setLoading } from "state/slices/loaderSlice";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { selectRole } from "state/slices/roleSlice";
const LawOfficerReport = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [reportData, setReportData] = useState([]);
  const role = useSelector(selectRole);
  useEffect(() => {
    loadReport();
  }, []);

  const loadReport = async () => {
    dispatch(setLoading(true));
    const res = await callApi("/v1/api/law-officer/report", "GET", null, false, true);
    if (res?.success) {
      setReportData(res.body?.body || []);
    }
    dispatch(setLoading(false));
  };

  const openCaseList = (officerId, statusType) => {
    navigate("/r-ca", {
      state: {
        filterType: "lawOfficer",
        officerId: officerId,
        statusType: statusType,
        period: "all",     // since no date grouping in this report
      },
    });
  };

  // ---------- CALCULATE TOTAL ----------
  const total = {
    assigned: 0,
    completed: 0,
    inProgress: 0,
  };

  reportData.forEach((r) => {
    total.assigned += r.assigned;
    total.completed += r.completed;
    total.inProgress += r.inProgress;
  });

  // ---------- CELL RENDER FUNCTION ----------
  const renderCell = (value, bgColor, officerId, statusType) => {
    if (value === 0) {
      return (
        <td style={{ backgroundColor: bgColor }} className="text-white">
          {value}
        </td>
      );
    }

    return (
      <td
        style={{
          backgroundColor: bgColor,
          cursor: "pointer",
          textDecoration: "underline",
        }}
        className="text-white"
        onClick={() => openCaseList(officerId, statusType)}
      >
        {value}
      </td>
    );
  };

  return (
    <>
      <div className="container mb-3">
        <div className="card">
          <div
            className="ms-3 me-3 mt-3 p-2 d-flex justify-content-between"
            style={{ backgroundColor: "#262E3D", borderRadius: "8px" }}
          >
            <div className="d-flex align-items-center">
              <span className="card-title text-white m-0">Advocates Report</span>
            </div>
            {role === "Admin" && (
              <button
                className="btn btn-sm btn-success"
                onClick={() =>
                  navigate("/grl", {
                    state: { reportType: "LawOfficerReport" },
                  })
                }
              >
                Generate Report
              </button>
            )}
          </div>
          <div className="card-body">
            <div className="table-responsive">
              <table className="table table-bordered text-center align-middle table-hover table-striped">
                <thead>
                  <tr>
                    <th
                      style={{ backgroundColor: "#262E3D" }}
                      className="text-center align-middle"
                    >
                      <span className="text-white">Advocate Name</span>
                    </th>
                    <th
                      style={{ backgroundColor: "#262E3D" }}
                      className="text-center align-middle"
                    >
                      <span className="text-white">Cases Assigned</span>
                    </th>
                    <th
                      style={{ backgroundColor: "#262E3D" }}
                      className="text-center align-middle"
                    >
                      <span className="text-white">
                        Cases Successfully Completed
                      </span>
                    </th>
                    <th
                      style={{ backgroundColor: "#262E3D" }}
                      className="text-center align-middle"
                    >
                      <span className="text-white">Cases In-Progress</span>
                    </th>
                  </tr>
                </thead>

                <tbody>
                  {reportData.map((row, index) => (
                    <tr key={index}>
                      <td className="bg-warning text-white">{row.officerName}</td>

                      {renderCell(row.assigned, "#00B0F0", row.officerId, "assigned")}
                      {renderCell(row.completed, "#00FF90", row.officerId, "completed")}
                      {renderCell(row.inProgress, "#FF4D4D", row.officerId, "inProgress")}
                    </tr>
                  ))}

                  <tr className="font-weight-bold">
                    <td style={{ backgroundColor: "#262E3D" }} className="text-white">
                      Total:
                    </td>
                    <td style={{ backgroundColor: "#262E3D" }} className="text-white">
                      {total.assigned}
                    </td>
                    <td style={{ backgroundColor: "#262E3D" }} className="text-white">
                      {total.completed}
                    </td>
                    <td style={{ backgroundColor: "#262E3D" }} className="text-white">
                      {total.inProgress}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default LawOfficerReport;
